import { useState } from 'react';
import './style.css';

const FloatingServiceButton = ({
  themeColor = '#3BBF9F',
  textColor = '#FFFFFF',
  onCallWaiter,
  onAskBill,
}) => {
  const [open, setOpen] = useState(false);
  const [loadingAction, setLoadingAction] = useState(null);

  const handleAction = async (type) => {
    setLoadingAction(type);

    try {
      if (type === 'waiter' && onCallWaiter) {
        await onCallWaiter();
      }
      if (type === 'bill' && onAskBill) {
        await onAskBill();
      }
    } finally {
      setTimeout(() => {
        setLoadingAction(null);
        setOpen(false);
      }, 600);
    }
  };

  return (
    <>
      {/* Overlay */}
      {open && <div className="fsb-overlay" onClick={() => setOpen(false)} />}

      {/* Menu */}
      <div className={`fsb-menu ${open ? 'open' : ''}`}>
        <button
          className="fsb-action"
          onClick={() => handleAction('waiter')}
          disabled={loadingAction}
        >
          {loadingAction === 'waiter' ? 'Chamando...' : '🛎️ Chamar garçom'}
        </button>

        <button
          className="fsb-action secondary"
          onClick={() => handleAction('bill')}
          disabled={loadingAction}
        >
          {loadingAction === 'bill' ? 'Solicitando...' : '💳 Pedir a conta'}
        </button>
      </div>

      {/* Botão flutuante */}
      {/* <button
        className={`fsb-button ${open ? 'active' : ''}`}
        onClick={() => setOpen(!open)}
        style={{
          backgroundColor: themeColor,
          color: textColor,
        }}
        aria-label="Serviço"
      >
        ☰
      </button> */}
    </>
  );
};

export default FloatingServiceButton;
